// src/components/HomePage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function HomePage() {
  const { user, loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="page">
      <div className="container">
        {/* Hero */}
        <div className="card" style={{ textAlign: 'center', padding: '2.5rem 1.5rem', marginBottom: '1.5rem' }}>
          <h1 style={{ fontSize: 26, fontWeight: 600, marginBottom: 10, letterSpacing: -0.5 }}>
            会議の日程調整を、シンプルに
          </h1>
          <p style={{ fontSize: 15, color: '#666', maxWidth: 480, margin: '0 auto 1.5rem' }}>
            候補日を設定してURLを共有するだけ。参加者はGoogleアカウントでも、名前だけでも回答できます。
          </p>
          {user ? (
            <button className="btn btn-primary" style={{ fontSize: 15, padding: '11px 28px' }} onClick={() => navigate('/create')}>
              + 新しい日程調整を作る
            </button>
          ) : (
            <button className="btn btn-primary" style={{ fontSize: 15, padding: '11px 28px' }} onClick={loginWithGoogle}>
              Googleでログインして始める
            </button>
          )}
        </div>

        {/* Features */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
          {[
            { icon: '🔒', title: 'Googleで安心', desc: '主催者はGoogleアカウントで認証。なりすましや重複作成を防止します。' },
            { icon: '👤', title: '参加者は手軽に', desc: 'GoogleでもゲストでもOK。名前だけで回答できます。' },
            { icon: '📊', title: '結果はリアルタイム', desc: '○△✕の集計をリアルタイム表示。最適な日程が一目でわかります。' },
          ].map(f => (
            <div key={f.title} className="card" style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>{f.icon}</div>
              <div className="font-medium" style={{ marginBottom: 6 }}>{f.title}</div>
              <p className="text-sm text-muted">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* How to use */}
        <div className="card" style={{ marginTop: '1rem' }}>
          <div className="card-title">使い方</div>

          {/* 主催者 */}
          <div style={{ marginBottom: 16 }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: '#E1F5EE', color: '#0F6E56',
              borderRadius: 6, padding: '3px 10px',
              fontSize: 13, fontWeight: 500, marginBottom: 10
            }}>
              🗓 主催者（イベントを作る方）
            </div>
            <ol style={{ paddingLeft: '1.2rem', display: 'flex', flexDirection: 'column', gap: 6 }}>
              <li className="text-sm">
                Googleアカウントでログインし、作成権限を申請する
                <span style={{
                  display: 'inline-block', marginLeft: 6,
                  background: '#FFF3E0', color: '#854F0B',
                  border: '0.5px solid #EF9F27',
                  borderRadius: 4, fontSize: 11, padding: '1px 6px'
                }}>要承認</span>
                <span className="text-muted" style={{ fontSize: 12, marginLeft: 4 }}>— 管理者が承認後に作成可能になります</span>
              </li>
              <li className="text-sm">候補日程を追加してイベントを作成</li>
              <li className="text-sm">発行されたURLを参加者にメール・チャットで共有</li>
              <li className="text-sm">結果ページで集計を確認して日程を確定</li>
            </ol>
          </div>

          <hr className="divider" />

          {/* 参加者 */}
          <div>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: '#E6F1FB', color: '#185FA5',
              borderRadius: 6, padding: '3px 10px',
              fontSize: 13, fontWeight: 500, marginBottom: 10
            }}>
              ✉️ 参加者（回答する方）
            </div>
            <ol style={{ paddingLeft: '1.2rem', display: 'flex', flexDirection: 'column', gap: 6 }}>
              <li className="text-sm">主催者から共有されたURLを開く</li>
              <li className="text-sm">GoogleアカウントでログインするかゲストとしてURLを開く</li>
              <li className="text-sm">各候補日に ○ / △ / ✕ を入力して送信</li>
              <li className="text-sm">結果ページでほかの参加者の回答や集計を確認</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
